import { Services } from "./client/services/services";

export const isServer = typeof window === 'undefined';
export const isClient = !isServer;
export const isLocal = isServer ? false : window?.location?.protocol === "file:";
export const services = new Services(isLocal ? "local" : "default");
